var initAccordion = function initAccordion() {
  var accordionItems = document.querySelectorAll('.accordion__item');
  if (accordionItems.length > 0) {
    accordionItems.forEach(function (item) {
      var button = item.querySelector('.accordion__button');
      var content = item.querySelector('.accordion__content');
      if (button && content) {
        var isAnimating = false;

        button.addEventListener('click', function (event) {
          event.stopPropagation();

          if (isAnimating) return;

          isAnimating = true;
          var expanded = button.getAttribute('aria-expanded') === 'true';

          button.setAttribute('aria-expanded', String(!expanded));
          content.setAttribute('aria-hidden', String(expanded));

          content.addEventListener('transitionend', function () {
            isAnimating = false;
            content.removeEventListener('transitionend', arguments.callee);
          });

          setTimeout(function () {
            isAnimating = false;
          }, 300);
        });
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', initAccordion);